import { useMemo } from "react";
import { useParticipantLayoutActive } from "./ParticipantLayoutContext";

export function getParticipantLayoutActionAvailability({ participantLayoutActive = false } = {}) {
  const available = !participantLayoutActive;

  return {
    participantLayoutActive: Boolean(participantLayoutActive),
    canBrowseAssets: available,
    canDropFilesToScene: available,
    canManageFiles: available,
    canSpawnChatMessages: available,
    canUploadFiles: available
  };
}

export function useParticipantLayoutActionAvailability() {
  const participantLayoutActive = useParticipantLayoutActive();

  return useMemo(() => getParticipantLayoutActionAvailability({ participantLayoutActive }), [participantLayoutActive]);
}
